import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormContext } from 'noood/contexts/contexts';
import { form_validator } from "../FormFieldValidator";
import Feedback from "../../feedback/Feedback";
import PropTypes from "prop-types";
import FlexJustified from "noood/comp/ui/containers/flex-boxes/FlexJustified";
import BlockDiv from "noood/comp/ui/containers/BlockDiv";
import * as stylex from "@stylexjs/stylex";
export default function Textarea(props) {
  var _formContext$formObj3, _formContext$formObj$, _formContext$formObj4, _value$trim$length, _value$trim, _Number, _value$trim$length2, _value$trim2;
  var formContext = useContext(FormContext);
  var thisTextarea = useRef();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    e = _useState2[0],
    set_e = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    set_value = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    isFocused = _useState8[0],
    setIsFocused = _useState8[1];
  useEffect(function () {
    set_value(props.value);
  }, [props.value]);
  useEffect(function () {
    var _formContext$formObj, _formContext$formObj2;
    set_value(formContext === null || formContext === void 0 || (_formContext$formObj = formContext.formObj) === null || _formContext$formObj === void 0 ? void 0 : _formContext$formObj[props.name]);
    if (formContext !== null && formContext !== void 0 && (_formContext$formObj2 = formContext.formObj) !== null && _formContext$formObj2 !== void 0 && _formContext$formObj2[props.name]) {
      thisTextarea.current.parentNode.dataset.replicatedValue = formContext.formObj[props.name];
    } else {
      thisTextarea.current.parentNode.dataset.replicatedValue = undefined;
    }
  }, [formContext === null || formContext === void 0 || (_formContext$formObj3 = formContext.formObj) === null || _formContext$formObj3 === void 0 ? void 0 : _formContext$formObj3[props.name]]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "grow-wrap"
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    ref: thisTextarea,
    value: (_formContext$formObj$ = formContext === null || formContext === void 0 || (_formContext$formObj4 = formContext.formObj) === null || _formContext$formObj4 === void 0 ? void 0 : _formContext$formObj4[props.name]) !== null && _formContext$formObj$ !== void 0 ? _formContext$formObj$ : '',
    onFocus: function onFocus(e) {
      return setIsFocused(true);
    },
    onBlur: function onBlur(e) {
      return setIsFocused(false);
    }
  }, stylex.props(ui.base, isFocused && ui.focused), {
    onChange: function onChange(e) {
      var _e$currentTarget$valu;
      if (props.maxLength && ((_e$currentTarget$valu = e.currentTarget.value) === null || _e$currentTarget$valu === void 0 ? void 0 : _e$currentTarget$valu.length) <= props.maxLength) {
        var _props$__collect;
        set_value(e.currentTarget.value);
        var _errors = form_validator.validate(props.validations, e.target.value);
        setErrors(_errors);
        formContext === null || formContext === void 0 || formContext.__collect(props.name, e.target.value, _errors);
        (_props$__collect = props.__collect) === null || _props$__collect === void 0 || _props$__collect.call(props, e.target.value);
      } else {
        var _props$__collect2;
        set_value(e.currentTarget.value);
        var _errors2 = form_validator.validate(props.validations, e.target.value);
        setErrors(_errors2);
        formContext === null || formContext === void 0 || formContext.__collect(props.name, e.target.value, _errors2);
        (_props$__collect2 = props.__collect) === null || _props$__collect2 === void 0 || _props$__collect2.call(props, e.target.value);
      }
    }
  }))), /*#__PURE__*/React.createElement(FlexJustified, null, props.caption && /*#__PURE__*/React.createElement(BlockDiv, {
    style: {
      color: "var(--shade-40)",
      fontSize: "13px"
    }
  }, props.caption), props.maxLength && 100 * ((_value$trim$length = value === null || value === void 0 || (_value$trim = value.trim) === null || _value$trim === void 0 || (_value$trim = _value$trim.call(value)) === null || _value$trim === void 0 ? void 0 : _value$trim.length) !== null && _value$trim$length !== void 0 ? _value$trim$length : 0) / props.maxLength > 30 && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      color: "var(--text-on-shade-secondary)"
    }
  }, (_Number = Number((_value$trim$length2 = value === null || value === void 0 || (_value$trim2 = value.trim) === null || _value$trim2 === void 0 || (_value$trim2 = _value$trim2.call(value)) === null || _value$trim2 === void 0 ? void 0 : _value$trim2.length) !== null && _value$trim$length2 !== void 0 ? _value$trim$length2 : 0)) !== null && _Number !== void 0 ? _Number : 0, "/", props.maxLength))), (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/React.createElement(Feedback, {
    errors: errors
  }));
}
Textarea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  __collect: PropTypes.func,
  value: PropTypes.string,
  validations: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  maxLength: PropTypes.number,
  caption: PropTypes.string
};
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".ev4745u8{border-color:var(--shade-10)}", 2000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1aj07ft{color:var(--text)}", 3000);
_inject(".evadl4dv{box-shadow:0 0 0 2px rgba(175,198,255,.21)}", 3000);
_inject(".ev1jqyx15{transition:box-shadow .1s}", 2000);
_inject(".ev1vy04nk{box-shadow:0 0 0 2px rgba(255,141,141,.62)}", 3000);
_inject(".evpz759w{border-color:var(--red-50)}", 2000);
var ui = {
  base: {
    "Textarea__ui.base": "Textarea__ui.base",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "ev4745u8",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    outline: "ev1a2a7pz",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    backgroundColor: "ev1y7ric0",
    color: "ev1aj07ft",
    $$css: true
  },
  focused: {
    "Textarea__ui.focused": "Textarea__ui.focused",
    boxShadow: "evadl4dv",
    transition: "ev1jqyx15",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  }
};